import { DURATION_IN_SECONDS, VirtualClassApiConfig } from '@/types/virtual-classes'

class ActiveTrainingService {
  getVirtualClassTotalTime(virtualClass: VirtualClassApiConfig) {
    return virtualClass.attributes[DURATION_IN_SECONDS]
  }
}

export const activeTrainingService = new ActiveTrainingService()